import About from '../sections/About';
import MissionVision from '../sections/MissionVision';
import WhyStandOut from '../sections/WhyStandOut';
import Team from '../sections/Team';
import Stats from '../sections/Stats';
import Clients from '../sections/Clients';
import CTA from '../sections/CTA';

export default function AboutPage() {
  return (
    <>
      <div className="page-top-spacer" />
      <About />
      <MissionVision />
      <WhyStandOut />
      <Team />
      <Stats />
      <Clients />
      <CTA />
    </>
  );
}
